import { render, staticRenderFns } from "./CellRendererImage.vue?vue&type=template&id=52a416ae&"
import script from "./CellRendererImage.vue?vue&type=script&lang=js&"
export * from "./CellRendererImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports